import { MAIN_ROUTES } from '@shared/constants/routes.constant';

export const ROUTE_WITH_HEADER_BUTTONS = [MAIN_ROUTES.HERO_CAMP];
